import * as Yup from 'yup';

export const EmailTemplate = {
	schema: Yup.object().shape({
		id: Yup.number().defined().optional(),
		name: Yup.string().default('').required('Required'),
		subject: Yup.string().default('').required('Required'),
		bodyHtml: Yup.string().default('').required('Required'),
	}),
};

export type EmailTemplateProps = Yup.InferType<typeof EmailTemplate.schema>;
